const CRC20_ABI = require('./crc20.json').abi;

module.exports = {
  CRC20_ABI,
};
